import { ISiteSAMLConfiguration } from '../types/ISiteSAMLConfiguration';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IGetSiteSAMLConfigurationParams {
}

export class GetSiteSAMLConfigurationRequest extends Request<IGetSiteSAMLConfigurationParams, ISiteSAMLConfiguration> {
  constructor() {
    super('getOrCreateSiteSAMLConfiguration', null);
  }
}
